import React, { useContext } from 'react';
import { RedocContext } from '../contexts';
import { RedocStandalone } from 'redoc';

export const RedocContainer = () => {
    const { specState } = useContext(RedocContext);

    if (specState.specUrl === undefined) {
        return <h3>Please select a version above.</h3>;
    }

    return (
        <RedocStandalone
            key={specState.specUrl}
            spec={null}
            specUrl={specState.specUrl}
            options={{
                nativeScrollbars: true,
                theme: {
                    colors: {
                        primary: { main: '#47bfee' }
                    },
                    spacing: {
                        sectionVertical: 10
                    }
                },
                jsonSampleExpandLevel: 3,
                requiredPropsFirst: true,
                expandSingleSchemaField: true,
                maxDisplayedEnumValues: 3,
                sortPropsAlphabetically: true,
                showExtensions: [ 'x-audience' ],
                hideDownloadButton: !specState.isInternal
            }}
        />
    );
};
